import { withBasePath } from "@/lib/portal/base-path";

/** Static brand assets under `public/glofox/brand/`. */
export const GLOFOX_BRAND_LOGO_WORDMARK = "/glofox/brand/logo.png";
export const GLOFOX_BRAND_LOGO_BADGE = "/glofox/brand/logo-teal.png";
export const GLOFOX_BRAND_LOGO_MARK = "/glofox/brand/mark.svg";
export const GLOFOX_BRAND_FAVICON = "/glofox/brand/favicon.svg";

export function getGlofoxBrandLogoWordmarkHref(): string {
  return withBasePath(GLOFOX_BRAND_LOGO_WORDMARK);
}

export function getGlofoxBrandLogoBadgeHref(): string {
  return withBasePath(GLOFOX_BRAND_LOGO_BADGE);
}

export function getGlofoxBrandLogoMarkHref(): string {
  return withBasePath(GLOFOX_BRAND_LOGO_MARK);
}
